var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "transfer-transaction-form",
      attrs: {
        visible: _vm.showModal,
        size: "small",
        title: _vm.$t.__(
          "bankreconciliation.TransferTransactionForm.transfer_transactions"
        )
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: _vm.close
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "dialog__default" },
          [
            _c("p", { staticClass: "grey mb-3" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Vous pouvez transférer des transactions d'un compte vers un autre."
                    )
                  ) +
                  "\n                "
              ),
              _c("br"),
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Permet de répondre à des problématiques de doublon de compte via les problèmes de synchronisation de Budget Insight."
                    )
                  ) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "form",
                attrs: {
                  model: _vm.form,
                  rules: _vm.rules,
                  labelPosition: "top"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "from_bank_account_id" } },
                  [
                    _c("template", { slot: "label" }, [
                      _c("span", { staticClass: "bold" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Je souhaite transférer les éléments du compte"
                              )
                            ) +
                            "\n                        "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        staticClass: "wp-10",
                        attrs: {
                          placeholder: _vm.$t.__(
                            "bankreconciliation.TransferTransactionForm.select_account"
                          )
                        },
                        model: {
                          value: _vm.form.from_bank_account_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "from_bank_account_id", $$v)
                          },
                          expression: "form.from_bank_account_id"
                        }
                      },
                      _vm._l(_vm.accounts, function(account) {
                        return _c("el-option", {
                          key: account.id,
                          attrs: {
                            label: account.label,
                            value: account.id,
                            disabled: _vm.form.to_bank_account_id === account.id
                          }
                        })
                      }),
                      1
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { prop: "to_bank_account_id" } },
                  [
                    _c("template", { slot: "label" }, [
                      _c("span", { staticClass: "bold" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$l10n.__("Vers le compte")) +
                            "\n                        "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        staticClass: "wp-10",
                        attrs: {
                          placeholder: _vm.$t.__(
                            "bankreconciliation.TransferTransactionForm.select_account"
                          )
                        },
                        model: {
                          value: _vm.form.to_bank_account_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "to_bank_account_id", $$v)
                          },
                          expression: "form.to_bank_account_id"
                        }
                      },
                      _vm._l(_vm.accounts, function(account) {
                        return _c("el-option", {
                          key: account.id,
                          attrs: {
                            label: account.label,
                            value: account.id,
                            disabled:
                              _vm.form.from_bank_account_id === account.id
                          }
                        })
                      }),
                      1
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-row ai-center" },
                  [
                    _c("span", { staticClass: "bold block" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$l10n.__(
                              "en comprenant les transactions du compte entre le"
                            )
                          ) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "mb-0 pl-2",
                        attrs: { prop: "daterange" }
                      },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            mode: "edit",
                            unlinkPanels: "",
                            align: "right",
                            type: "daterange",
                            defaultValue: _vm.setDefaultDate,
                            valueFormat: "yyyy-MM-dd HH:mm:ss",
                            format: _vm.datePickerFormat,
                            rangeSeparator: _vm.$t.__("common.labels.to"),
                            pickerOptions: _vm.pickerOptions
                          },
                          on: { change: _vm.handleDateChange },
                          model: {
                            value: _vm.daterange,
                            callback: function($$v) {
                              _vm.daterange = $$v
                            },
                            expression: "daterange"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { staticClass: "mt-4" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { value: true },
                        model: {
                          value: _vm.form.remove_current_transaction,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "remove_current_transaction",
                              $$v
                            )
                          },
                          expression: "form.remove_current_transaction"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$l10n.__(
                              "Écraser les transactions sur le compte d'arrivée"
                            )
                          )
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-row flex-right mt-4" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.cancel"),
                        type: "secondary"
                      },
                      on: { click: _vm.close }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__("common.actions.transfer"),
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.submit()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }